import { createFileRoute } from '@tanstack/react-router';
import { filtersFromSearch, filtersToQuery } from '../../import/model/match-model.js';
import { RunPage } from '../../import/RunPage.js';

export interface RunSearch {
  step?: string | undefined;
  tier?: string;
  choice?: string;
  reimport?: string;
  type?: string;
  skipped?: string;
  /** "Import again": the earlier run whose mapping the draft carries. */
  from?: string | undefined;
}

export const Route = createFileRoute('/import/$runId')({
  // `step` is always named, `undefined` when not a string: the router spreads this answer over
  // the raw search, so a key left out would let a raw number or array through as the step.
  // The match review's filters ride in the same search (`tier`, `choice`, `reimport`, `type`,
  // `skipped`); a value that is not one of the allowed ones is dropped.
  validateSearch: (search: Record<string, unknown>): RunSearch => ({
    step: typeof search.step === 'string' ? search.step : undefined,
    from:
      typeof search.from === 'string' && /^[0-9a-f-]{36}$/.test(search.from)
        ? search.from
        : undefined,
    ...filtersToQuery(filtersFromSearch(search)),
  }),
  component: RunRoute,
});

function RunRoute(): React.JSX.Element {
  const { me } = Route.useRouteContext();
  const { runId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <RunPage
      me={me}
      runId={runId}
      step={search.step}
      from={search.from}
      filters={filtersFromSearch(search as Record<string, unknown>)}
    />
  );
}
